export default "__VITE_ASSET__Bc8v8vQc__"